import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { FieldMetaData } from './types';

type AgeTFCProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  onChange: (value: number, fieldMetaData: FieldMetaData) => void;
  initialValue?: number;
};

export default function AgeTFC({ onChange, initialValue = 0, ...props }: AgeTFCProps) {
  const [value, setValue] = useState(initialValue);

  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newAgeParsed = parseInt(event.target.value);
    const newValue = Number.isNaN(newAgeParsed)
      ? Number.NaN
      : newAgeParsed < 0
        ? newAgeParsed * -1
        : newAgeParsed;

    setValue(newValue);

    const state = newValue === 0 || Number.isNaN(newAgeParsed) ? 'empty' : 'valid';

    onChange(newValue, { state, error: null });
  };

  const derivedValue = Number.isInteger(value) && value > 0 ? String(value) : '';

  return (
    <TextField
      value={derivedValue}
      onChange={handleOnChange}
      placeholder="Enter an age"
      inputMode="numeric"
      type="text"
      sx={{ width: '223px' }}
      slotProps={{
        htmlInput: {
          min: '0',
        },
      }}
      color="secondary"
      {...props}
    />
  );
}
